<template>
    <div class="facet-container" :class="{'open': openFacets}">
        <div class="facets">
            <MultiSelect class="n-ml hide-small" itemType="results"></MultiSelect>
            <h3>{{ $t('labels.refine_results') }}</h3>
            <button @click="closeFacets" class="close-facet" ref="closeButton">
                <span class="sr-only">{{ $t('labels.close_facets') }}</span>
                <span class="close-icon" aria-hidden="true"></span>
            </button>
            <div class="options-container">
                <label for="facet-opt-online" class="online-box">
                    <span class="facet-name">{{ $t('labels.available_online') }}</span>
                    <input 
                        type="checkbox" 
                        id="'facet-opt-online" 
                        name="media" 
                        value="_exists" 
                        @click="refineResults" 
                        :checked="isSelected({name: 'media', value: '_exists'})">
                </label>            
                <!-- <label for="facet-opt-images" class="image-box">
                    <span class="facet-name">{{ $t('labels.images_only') }}</span>
                    <input 
                        type="checkbox" 
                        id="'facet-opt-images" 
                        name="media.mime_type" 
                        value="image" 
                        @click="refineResults" 
                        :checked="isSelected({name: 'media.mime_type', value: 'image'})">
                </label>             -->
                <details v-for="(value, key) in facets" :key="key" :open="hasSelection(value.name)">
                    <summary class="facet-summary">
                        <span class="facet-name">{{ key }}</span>
                        <span class="expand-icon" aria-hidden="true"></span>
                    </summary>

                    <div class="facet-content">
                        <label :for="'facet-opt-' + slug(text)" v-for="text in value.options" :key="slug(text)">
                            <input 
                                type="checkbox" 
                                :id="'facet-opt-'+ slug(text)" 
                                :name="value.name" 
                                :value="text" 
                                @click="refineResults" 
                                :checked="isSelected({name: value.name, value: text})">
                            <span>{{ text }}</span>
                        </label>
                    </div>
                </details>
            </div>
        </div>

        <button type="button" @click="clearFacets" class="clear-button" v-if="Object.keys(selected_facets).length">
            {{ $t('labels.clear_all') }}
        </button>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MultiSelect from '../components/MultiSelect'

export default {
    data () {
        return {
            selectedValues: {},
            facetNameMap: this.$i18n.messages[this.$i18n.locale].facet_options_map,
            openFacets: false
        }
    },
    components: {
        MultiSelect,
    },
    computed: {
        ...mapGetters({
            'all_facets': 'search/facets',
            'selected_facets': 'search/selected_facets',
            'check_selected_items': 'list/selected',
        }),
        'facets': function () {
            if (!this.all_facets) return;
            let facets = {};
            Object.keys(this.all_facets).forEach(f => {
                if (this.all_facets[f].length > 0) {
                    let fName = this.facetNameMap[f];
                    if (!fName) return;
                    let options = [...this.all_facets[f]].sort((a,b) => {
                        return a < b ? -1 : 1; 
                    });

                    facets[fName] = {
                        name: f,
                        options: options
                    };
                }
            });

            return facets;
        }
    },
    methods: {
        slug (text) {
            return text.replaceAll(',', ' ').replaceAll(' ', '-');
        },
        isSelected(t) {
            if (!this.selected_facets) return false;
            return this.selected_facets[t.name] && this.selected_facets[t.name].includes(t.value);
        },
        refineResults(e) {
            let name = e.target.name;
            let value = e.target.value;

            if (this.check_selected_items.length > 0) {
                let msg =  this.$i18n.messages[this.$i18n.locale].clear_selected_modal.text
                let okay = confirm(msg)
                if (!okay) {
                    e.target.checked = !e.target.checked;
                    return;
                }
            }

            if (this.isSelected({name: name, value: value})) {
                this.$emit('removeFacet', {
                    name: name,
                    value: value
                })
            } else {
                this.$emit('addFacet', {
                    name: name,
                    value: value
                })
            }
        },
        clearFacets: function() {
            this.$store.dispatch('search/resetFacets').then(() => {
                this.$emit('clearFacets', {page: 1});
            })
        },
        hasSelection: function (facet) {
            return facet in this.selected_facets;
        },
        expand() {
            this.openFacets = true;
            this.$refs.closeButton.focus();
        },
        closeFacets () {
            this.openFacets = false;
            this.$emit('closed')
        },
    }
}
</script>

<style scoped lang="scss">
.facet-container {
    width: 20%;
    min-width: 300px;
    position: sticky;
    top: 6.125rem;
    align-self: flex-start;
    height: 90vh;
    background: $white;
    z-index: 4;
    overflow-y: auto;
    overflow-x: hidden;

    .close-facet {
        display: none;
    }
}

.options-container {
    width: 100%;
    height: 60vh;
    overflow-y: auto;
    padding-right: 1.5rem;
    display: flex;
    flex-direction: column;
    // justify-content: space-evenly;

    .facet-name {
        text-transform: uppercase;
        font-family: $futuraBold;
        font-weight: bold;
    }

    .image-box, .online-box {
        padding: .5rem 0;
        display: flex;
        justify-content: space-between;    
        flex-basis: 8%;
        flex-grow: 1;
        max-height: 5rem;
        align-items: center;
    }

    // .online-box { // don't need if no images only toggle
    //     border-bottom: $thin-gray-border; 
    //     padding-bottom: $s2;
    // }

}

h3 {
    margin-top: 3.313rem;
    margin-bottom: 1.563rem;
}

.clear-button {
    background: none;
    border: none;
    font-family: 'Futura';
    margin: $s2 0;
    padding: 0;
    text-decoration: underline;
}

.facets {
    flex-basis: 30%;
    min-width: 270px;
    flex-shrink: 0;
    border-bottom: $thin-gray-border;
    height: fit-content;
    margin-right: $side-padding;
    margin-top: 1rem;

    details {
        flex-basis: 8%;
        flex-grow: 1;
        max-height: 5rem;

        &[open] {
            max-height: unset;
        }
    }

    summary {
        height: 100%;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        border-top: $thin-gray-border;
        list-style: none;
        padding: .5rem 0;
        max-height: 5rem;
        height: 5rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        &::-webkit-details-marker, &::marker {
            display: none;
        }

        .expand-icon:after {
            content: url('../assets/images/icon-plus.svg');
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    details[open] {
        summary {
            .expand-icon:after {
                content: url('../assets/images/icon-minus.svg');
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }

    .facet-content label {
        margin: .4rem 0;
        display: block; 
        line-height: 1.4rem;
        display: flex;
        justify-content: flex-start;

        input {
            margin-right: .5rem;
            margin-top: 5px;
        }

        &:last-child {
            margin-bottom: $s2;
        }
    }
}

@media (max-width: $mq-max-width-desktop) {
       
    h3 {
        margin-top: 1.313rem;
    }
    .facet-container {
        min-width: unset;
        .facets {
            min-width: unset;
            font-size: .8rem;
        }
    }

}
@media (max-width: $mq-max-width-tablet) {
 
    .facet-container {
        position: fixed;
        left: -800px;
        transition: left 250ms ease-in-out;

        .close-facet {
            display: block;
        }
            
        &.open {
            z-index: 5;
            background: $white;
            top: 0;
            left: 0;
            width: 100%;
            padding-left: $side-padding-mobile;
            padding-right: $side-padding-mobile;

            .options-container {
                height: 80vh;
            }

            .close-facet {
                position: fixed;
                top: $side-padding-mobile;
                right: $side-padding-mobile;
                background: none;
                border: none;
            }

            .close-icon {
                display: block;
                cursor: pointer;

                &:after {
                    content: '';
                    background-image: url('../assets/images/icon-close-x.svg');
                    background-size: contain;
                    display: block;
                    height: 20px;
                    width: 20px;
                    position: relative;
                }
            }
        }
    }

}

@media print {
    .facet-container {
        display: none;
    }
}
</style>